import React from "react";
import { ChevronRight } from "lucide-react";

const SubsidiaryHierarchyBreadcrumb = ({ subsidiary, subsidiaries = [] }) => {
  const buildHierarchy = (sub) => {
    const hierarchy = [sub];
    let current = sub;
    
    // Build hierarchy by traversing parent relationships
    while (current.parent_id) {
      const parent = subsidiaries.find(s => s.id === current.parent_id);
      if (parent) {
        hierarchy.unshift(parent);
        current = parent;
      } else {
        break;
      }
    }
    
    return hierarchy;
  };
  
  if (!subsidiary) return null;
  
  const hierarchy = buildHierarchy(subsidiary);
  
  // If only one level (no parent), don't show breadcrumb
  if (hierarchy.length === 1) {
    return <span className="font-medium">{subsidiary.name}</span>;
  }
  
  return (
    <div className="flex items-center gap-1 text-sm">
      {hierarchy.map((item, index) => (
        <React.Fragment key={item.id}>
          {index > 0 && <ChevronRight className="h-3 w-3 text-gray-400" />}
          <span
            className={
              index === hierarchy.length - 1
                ? "font-medium text-gray-900"
                : "text-gray-500"
            }
          >
            {item.name}
          </span>
        </React.Fragment>
      ))}
    </div>
  );
};

export default SubsidiaryHierarchyBreadcrumb;
